export default "__VITE_ASSET__0lWcabCB__"